
import React from 'react';

const PhoneUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M23.5 30h-16v2h16v-2zM25.5 9V6h-1V3c0-1.65-1.35-3-3-3h-12c-1.65 0-3 1.35-3 3v21c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V13h1v-2h-1V9h1zm-16-7h12c.55 0 1 .45 1 1h-13v2h13v14h-14V3c0-.55.45-1 1-1zm12 23h-12c-.55 0-1-.45-1-1v-3h14v3c0 .55-.45 1-1 1z'
			></path>
			<path fill='#2d2d2d' d='M16.5 21h-2v2h2v-2z'></path>
		</svg>
	);
};

export default PhoneUnderline;
